module.exports = {
    namespace: 'customers',

    da: {
        forms: {
            isCompany: 'Har du en virksomhed?',
            isCompanyCheckboxText: 'Jeg har en virksomhed med aktivt CVR nummer.',
            isCompanyHelpText: 'Ved at indtaste dit CVR-nummer kan du få vist priserne eks. moms.',
        },
    },

    en: {
        forms: {
        },
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/customers/locales/index.js